import { render, staticRenderFns } from "./FAQAccordionItem.vue?vue&type=template&id=7a1ac794&"
import script from "./FAQAccordionItem.vue?vue&type=script&lang=js&"
export * from "./FAQAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./FAQAccordionItem.vue?vue&type=style&index=0&id=7a1ac794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports